import React from 'react'
import Dropzone from 'react-dropzone'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Button, Card, CardText } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './FileUpload.scss'

class FileUpload extends React.Component {
    static propTypes = {
        showStatus: PropTypes.bool,
        showAddButton: PropTypes.bool,
        disabled: PropTypes.bool,
        disableClick: PropTypes.bool,
        multiple: PropTypes.bool,
        style: PropTypes.object,
        onReject: PropTypes.func,
        onAccept: PropTypes.func,
        onDrop: PropTypes.func,
        className: PropTypes.string,
        emptyStatusText: PropTypes.string
    }

    static defaultProps = {
        showStatus: false,
        showAddButton: true,
        disabled: false,
        disableClick: false,
        multiple: false,
        style: {}
    }

    state = {
        file: {},
        status: this.props.showStatus && this.props.emptyStatusText
    }

    handleDrop = (accepted, rejected) => {
        if (this.props.onDrop) {
            this.props.onDrop(accepted, rejected)
        }

        if (accepted) {
            const file = accepted[0]
            this.setState({
                file,
                status: file.name
            }, this.props.onAccept(file))
        } else {
            this.setState({
                status: 'Bestand is niet geaccepteerd'
            }, this.props.onReject(rejected))
        }
    }

    render() {
        const classes = cx('ao-fileupload-container', this.props.className)
        const { showStatus, showAddButton, disabled, disableClick, style, multiple } = this.props

        return (
            <div className={ classes }>
                <Dropzone disabled={ disabled } disableClick={ disableClick } style={ style } multiple={ multiple } onDrop={ this.handleDrop }>
                    <Card body className="text-center ao-fileupload__content">
                        { showAddButton && (
                            <Button disabled={ this.props.disabled } className="ao-fileupload__button" color="primary">
                                <FontAwesomeIcon icon="plus" />
                            </Button>
                        )}

                        { showStatus && (
                            <div className="ao-fileupload__text">
                                <CardText>
                                    { this.state.status }
                                </CardText>
                            </div>
                        )}

                    </Card>
                </Dropzone>
            </div>
        )
    }
}

export default FileUpload
